import CustomButton from '../reusable/CustomButton';
import CustomModal from '../reusable/CustomModal';

import './CourseMappingUnsavedChangesModal.css';

interface CourseMappingUnsavedChangesModalProps {
  isOpen: boolean;
  isSaving: boolean;
  onClose: () => void;
  onDiscard: () => void;
  onSave: () => void;
}

const CourseMappingUnsavedChangesModal = ({
  isOpen,
  isSaving,
  onClose,
  onDiscard,
  onSave,
}: CourseMappingUnsavedChangesModalProps) => (
  <CustomModal title="Unsaved changes" isOpen={isOpen} handleClose={onClose} icon={false} maxWidth="xs">
    <p className="course-mapping-unsaved-changes-message">
      You&apos;re about to leave this view with unsaved changes. Would you like to save them first?
    </p>
    <div className="custom-modal-actions-container">
      <CustomButton
        variant="secondary"
        size="medium"
        buttonText="Don't save"
        buttonAction={onDiscard}
        disabled={isSaving}
      />
      <CustomButton
        variant="primary"
        size="medium"
        buttonText="Save changes"
        buttonAction={onSave}
        loading={isSaving}
      />
    </div>
  </CustomModal>
);

export default CourseMappingUnsavedChangesModal;
